import { Version } from '@angular/core';

export const VERSION = new Version('10.0.2');
